import { createSlice } from '@reduxjs/toolkit';
import { getTokens } from '../../utils/tokenUtils';
import { loginUser, logoutUser } from './authActions';

// Get initial token data
const tokenData = getTokens();

// Initial state
const initialState = {
    user: tokenData?.userData || null,
    accessToken: tokenData?.accessToken || null,
    refreshToken: tokenData?.refreshToken || null,
    isAuthenticated: !!tokenData?.accessToken,
    loading: false,
    error: null
};

// Create the slice
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Login
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.isAuthenticated = true;
                state.user = action.payload.user;
                state.accessToken = action.payload.accessToken;
                state.refreshToken = action.payload.refreshToken;
                state.error = null;
            })
            .addCase(loginUser.rejected, (state, action) => {
                console.log("login rejected");
                state.loading = false;
                state.isAuthenticated = false;
                state.error = action.payload?.message || 'Login failed';
            })
            // Logout
            .addCase(logoutUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.loading = false;
                state.isAuthenticated = false;
                state.user = null;
                state.accessToken = null;
                state.refreshToken = null;
                state.error = null;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Logout failed';
            });
    }
});

export const { clearError } = authSlice.actions;
export default authSlice.reducer; 